export default __webpack_public_path__ + "static/integrationBg-7241daeac7f980c90ff40c715ef84059.png";